import CrudRequest from '@rootCommon/services/crud-request';
import { IP_WHITELIST_RECORD } from '@rootCommon/constants/end-points';
import { IpWhitelistRecord, IpWhitelistRecordDto, IpWhitelistRecordUpdateDto } from '@rootCommon/types/fhq';
import { IdType } from '@rootCommon/types/common';
import { ADMIN } from '@rootCommon/constants/common';

const IP_WHITE_LIST_RECORD_ADMIN = `${IP_WHITELIST_RECORD}/${ADMIN}`;
const IP_WHITE_LIST_RECORD_ADMIN_ALL = `${IP_WHITELIST_RECORD}/all/${ADMIN}`;

class FhqGeneralSettingService extends CrudRequest<
IpWhitelistRecord,
IpWhitelistRecordDto | IpWhitelistRecordUpdateDto
> {
  constructor() {
    super(IP_WHITE_LIST_RECORD_ADMIN);
  }

  getListBySiteId = async (siteId: IdType): Promise<IpWhitelistRecord> => {
    const res = await CrudRequest.get<IpWhitelistRecord>(IP_WHITE_LIST_RECORD_ADMIN_ALL, {
      params: { siteId },
    });

    return res.data;
  };
}

export default new FhqGeneralSettingService();
